import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form', 'input', 'removeForm']

  openFilePicker(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  upload() {
    if (this.inputTarget.files.length > 0) {
      this.formTarget.requestSubmit()
    }
  }

  remove(event) {
    event.preventDefault()
    this.removeFormTarget.requestSubmit()
  }
}
